import React from "react";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import WarningIcon from "@material-ui/icons/Warning";

const useStyles = makeStyles(() => ({
  icon: {
    float: "left",
    margin: "0 20px 20px 0",
    height: "100%",
    fill: "white",
  },
  createButton: {
    backgroundColor: '#1A9FE0',
    width: 140,
    fontWeight: 800,
    textTransform: 'inherit',
    fontFamily: 'Nunito',
    fontSize: '0.688rem',
    color: '#FFFFFF',
    borderRadius: '2.5rem',
    height: 35,
    textAlign: 'center',
    marginRight: 8
  },
  closeButton: {
    backgroundColor: '#EAEAEA',
    width: 140,
    fontWeight: 800,
    textTransform: 'capitalize',
    fontFamily: 'Nunito',
    fontSize: '0.688rem',
    color: '#666666',
    borderRadius: '2.5rem',
    height: 35,
    textAlign: 'center',
    marginRight: 24
  }
}));

export default function TradePointAccessDialog(props: any) {
  const classes = useStyles();

  return (
    <div className="float-left mb-2 mt-2">
      <Dialog
        open={props.open ? true : false}
        onClose={() => { props.handleopenClose(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}>
        <DialogContent>
          <div className={classes.icon}>
            <WarningIcon className="delete-warning" fontSize="small" />
          </div>
          <div>
            <DialogContentText id="alert-dialog-description">
              <div className="mt-2">
                {props.isTradePointAccess ?
                  <h5 className="submit-dialog-content">Do you wish to disable the Tradepoint access to the Customer ?</h5>
                  :
                  <h5 className="submit-dialog-content">Do you wish to provide the Tradepoint access to the Customer ?</h5>
                }
              </div>
              <div className="pr-2 mb-2 pl-0">
              </div>
            </DialogContentText>
          </div>
        </DialogContent>
        <DialogActions className="mt-3 mb-3 justify-content-end">
          <Button variant="contained"
            color="secondary" className={`createFavourite ${classes.createButton}`}
            onClick={() => {
              props.handleopenClose('Submit')
            }}>Yes
          </Button>
          <Button variant="contained" className={classes.closeButton}
            onClick={() => {
              props.handleopenClose(false)
            }}>No
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
}
